'use strict';

var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var ListItemText = require('../../../DataDisplay/List/ListItemText.js');
var Avatar = require('../../../DataDisplay/Avatar/Avatar.js');
var List = require('../../../../node_modules/@material-ui/core/esm/List/List.js');
var ListItem = require('../../../../node_modules/@material-ui/core/esm/ListItem/ListItem.js');
var ListItemIcon = require('../../../../node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var FranchiseesMenu = function FranchiseesMenu(_ref) {
  _ref.classes;
      var franchisees = _ref.franchisees;
      objectWithoutProperties(_ref, ["classes", "franchisees"]);

  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(List["default"], {
    component: "nav"
  }, franchisees.map(function (franchisee, index) {
    return React__default["default"].createElement(ListItem["default"], {
      button: true,
      key: '1',
      onClick: function onClick() {
      }
    }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Avatar, {
      variant: "square",
      src: franchisee.logo_url
    }, franchisee.logo_url ? null : franchisee.company_name.slice(0, 1))), React__default["default"].createElement(ListItemText, {
      primary: franchisee.company_name,
      secondary: franchisee.location + ' (' + franchisee.id + ')'
    }));
  })));
};

module.exports = FranchiseesMenu;
